import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AnimatedSection from './AnimatedSection';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 bg-cream">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <AnimatedSection animation="fadeLeft" className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t border-l border-gold"></div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b border-r border-gold"></div>
            <img 
              src="/images/foto-angel-scrubs.jpeg"
              alt="Dr. Ángel Norro"
              className="w-full h-auto"
            />
          </AnimatedSection>

          {/* Content */}
          <div>
            <AnimatedSection animation="fadeUp" delay={0.1}>
              <p className="eyebrow mb-6">{t('about.eyebrow')}</p>
            </AnimatedSection>
            
            <AnimatedSection animation="fadeUp" delay={0.2}>
              <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-6">
                {t('about.title')}
              </h2>
            </AnimatedSection>
            
            <AnimatedSection animation="fadeUp" delay={0.3}>
              <div className="w-16 h-px bg-gold mb-8"></div>
            </AnimatedSection>
            
            <AnimatedSection animation="fadeUp" delay={0.4}>
              <div className="space-y-6 text-text-secondary leading-relaxed">
                <p>{t('about.description')}</p>
                <p>{t('about.paragraph2')}</p>
                <p>{t('about.paragraph3')}</p>
              </div>
            </AnimatedSection>
            
            <AnimatedSection animation="fadeUp" delay={0.5}>
              <button 
                onClick={() => {
                  const el = document.getElementById('servicios');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="btn-outline-gold mt-8 inline-flex items-center gap-2 group"
                data-testid="view-all-procedures-btn"
              >
                {t('services.viewAll')}
                <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
